export const setRoomName = (name) => ({
	type    : 'SET_ROOM_NAME',
	payload : { name }

});

export const setWatermark = (watermark) => ({
	type    : 'SET_WATERMARK',
	payload : { watermark }
});

export const setSnackBarOpen = (flag) => ({
	type    : 'SET_SNACKBAR_OPEN',
	payload : { flag }
});

export const setSnackBarTipType = (tipType) => ({
	type    : 'SET_SNACKBAR_TIP_TYPE',
	payload : { tipType }
});

export const setVoteUpdated = (voteUpdated) => ({
	type    : 'SET_VOTE_UPDATED',
	payload : { voteUpdated }
});

export const setJoining = (flag) => ({
	type    : 'SET_JOINING',
	payload : { flag }
});

export const setWindowOpenName = (name) => ({
	type    : 'SET_WINDOW_OPEN_NAME',
	payload : { windowOpenName : name }
});

export const setRoomState = (state) => ({
	type    : 'SET_ROOM_STATE',
	payload : { state }

});

export const setFilmstripSelectedId = (peerId) => ({
	type    : 'SET_FILMSTRIP_SELECTED_ID',
	payload : { peerId }
});

export const setRoomActiveSpeakerId = (peerId) => ({
	type    : 'SET_ROOM_ACTIVE_SPEAKER',
	payload : { peerId }
});

export const setRoomLocked = () => ({
	type : 'SET_ROOM_LOCKED'
});

export const setRoomDelaying = (flag) => ({
	type : 'SET_ROOM_DELAYING',
	payload: { flag }
});

export const setRoomShutting = (flag) => ({
	type : 'SET_ROOM_SHUTTING',
	payload: { flag }
});

export const setRoomUnLocked = () => ({
	type : 'SET_ROOM_UNLOCKED'
});

export const setInLobby = (inLobby) => ({
	type    : 'SET_IN_LOBBY',
	payload : { inLobby }
});

export const setSignInRequired = (signInRequired) => ({
	type    : 'SET_SIGN_IN_REQUIRED',
	payload : { signInRequired }
});

export const setOverRoomLimit = (overRoomLimit) => ({
	type    : 'SET_OVER_ROOM_LIMIT',
	payload : { overRoomLimit }
});

// bingofree - 修改
export const setMaxUsersPerRoom = (maxUsersPerRoom) => ({
	type    : 'SET_MAX_USERS_PER_ROOM',
	payload : { maxUsersPerRoom }
});

export const setAccessCode = (accessCode) => ({
	type    : 'SET_ACCESS_CODE',
	payload : { accessCode }
});

export const setJoinByAccessCode = (joinByAccessCode) => ({
	type    : 'SET_JOIN_BY_ACCESS_CODE',
	payload : { joinByAccessCode }
});

export const setSettingsOpen = (settingsOpen) => ({
	type    : 'SET_SETTINGS_OPEN',
	payload : { settingsOpen }
});

export const setExtraVideoOpen = (extraVideoOpen) => ({
	type    : 'SET_EXTRA_VIDEO_OPEN',
	payload : { extraVideoOpen }
});

export const setHelpOpen = (helpOpen) => ({
	type    : 'SET_HELP_OPEN',
	payload : { helpOpen }
});

export const setAboutOpen = (aboutOpen) => ({
	type    : 'SET_ABOUT_OPEN',
	payload : { aboutOpen }
});

export const setSettingsTab = (tab) => ({
	type    : 'SET_SETTINGS_TAB',
	payload : { tab }
});

export const setLockDialogOpen = (lockDialogOpen) => ({
	type    : 'SET_LOCK_DIALOG_OPEN',
	payload : { lockDialogOpen }
});

export const setShareDialogOpen = (shareDialogOpen) => ({
	type    : 'SET_SHARE_DIALOG_OPEN',
	payload : { shareDialogOpen }
});

export const setFileSharingSupported = (supported) => ({
	type    : 'FILE_SHARING_SUPPORTED',
	payload : { supported }
});

export const toggleConsumerWindow = (consumerId) => ({
	type    : 'TOGGLE_WINDOW_CONSUMER',
	payload : { consumerId }
});
export const setWindowConsumerId = (consumerId) =>
({
	type    : 'SET_WINDOW_CONSUMER_ID',
	payload : { consumerId }	
});

export const toggleWindowPeerId = (peerId) => ({
	type    : 'TOGGLE_WINDOW_PEER_ID',
	payload : { peerId }
});
export const setWindowPeerId = (peerId) => ({
	type    : 'SET_WINDOW_PEER_ID',
	payload : { peerId }
});

export const toggleWindowVideoSource = (videoSource) => ({
	type    : 'TOGGLE_WINDOW_VIDEO_SOURCE',
	payload : { videoSource }
});
export const setWindowVideoSource = (videoSource) => ({
	type    : 'SET_WINDOW_VIDEO_SOURCE',
	payload : { videoSource }
});

export const setHoverPeerId = (peerId) => ({
	type    : 'SET_HOVER_PEER_ID',
	payload : { peerId }
});

// 设置打开新窗口
export const setNewWindowOpen = (flag) => ({
	type    : 'NEW_WINDOW_OPEN',
	payload : { flag }
});

export const setToolbarsVisible = (toolbarsVisible) => ({
	type    : 'SET_TOOLBARS_VISIBLE',
	payload : { toolbarsVisible }
});

export const setTopBarMoreAnchorEl = (target) => ({
	type    : 'SET_TOP_BAR_MORE_ANCHOREL',
	payload : { target }
});

// 开启强制模式
export const setForceMode = (flag) => ({
	type    : 'SET_FORCE_MODE',
	payload : { flag }
});

// 设置会议室是否有共享
export const setScreenSharing = (flag) => ({
	type    : 'SET_SCREEN_SHARING',
	payload : { flag }
});

// 设置自己是否共享了视频
export const setMyScreenSharing = (flag) => ({
	type    : 'SET_MY_SCREEN_SHARING',
	payload : { flag }
});

export const setHistoryMode = (mode) => ({
	type    : 'SET_HISTORY_MODE',
	payload : { mode }
});

export const setDisplayMode = (mode) => ({
	type    : 'SET_DISPLAY_MODE',
	payload : { mode }
});

// 设置布局配置
export const setLayoutConfig = (layoutConfig) => ({
	type    : 'SET_LAYOUT_CONFIG',
	payload : { layoutConfig }
});

// bingofree - 添加
export const setLayoutOpen = (layoutOpen) => ({
	type    : 'SET_LAYOUT_OPEN',
	payload : { layoutOpen }
});

export const setVoteOpen = (voteOpen) => ({
	type    : 'SET_VOTE_OPEN',
	payload : { voteOpen }
});

export const setSubtitleOpen = (subtitleOpen) => ({
	type    : 'SET_SUBTITLE_OPEN',
	payload : { subtitleOpen }
});

// bingofree 修改
export const setLayoutTab = (tab) =>
({
	type    : 'SET_LAYOUT_TAB',
	payload : { tab }
});

export const toggleFilterVideo = (flag) =>
({
	type    : 'TOGGLE_FILTER_VIDEO',
	payload : { flag }
});

export const setRemoteFilterVideo = (flag) =>
({
	type    : 'SET_REMOTE_FILTER_VIDEO',
	payload : { flag }
});

export const setFilterVideo = (flag) =>
({
	type    : 'SET_FILTER_VIDEO',
	payload : { flag }
});

export const setSpotlights = (spotlights) =>
({
	type    : 'SET_SPOTLIGHTS',
	payload : { spotlights }
});

export const clearSpotlights = () =>
({
	type : 'CLEAR_SPOTLIGHTS'
});

export const setJoined = (flag) =>
({
	type : 'SET_JOINED',
	payload : { flag }
});

export const setRollcall = (flag) =>
({
	type : 'SET_ROLLCALL',
	payload : { flag }
});

export const toggleConsumerFullscreen = (consumerId) =>
({
	type    : 'TOGGLE_FULLSCREEN_CONSUMER',
	payload : { consumerId }
});

export const closeConsumerFullscreen = () =>
({
	type    : 'CLOSE_FULLSCREEN_CONSUMER'
});

export const setLobbyPeersPromotionInProgress = (flag) =>
({
	type    : 'SET_LOBBY_PEERS_PROMOTION_IN_PROGRESS',
	payload : { flag }
});

export const setMuteAllInProgress = (flag) =>
({
	type    : 'MUTE_ALL_IN_PROGRESS',
	payload : { flag }
});

export const setForceMuteAllInProgress = (flag) =>
({
	type    : 'FORCE_MUTE_ALL_IN_PROGRESS',
	payload : { flag }
});

export const setIsForceMuteAll = (flag) =>
({
	type    : 'SET_IS_FORCE_MUTE_ALL',
	payload : { flag }
});

export const setMeIsRecording = (flag) =>
({
	type    : 'SET_ME_IS_RECORDING',
	payload : { flag }
});

export const setHasRecording = (flag) =>
({
	type    : 'SET_HAS_RECORDING',
	payload : { flag }
});

export const setRecordErrCode = (errCode) => ({
	type    : 'SET_RECORD_ERR_CODE',
	payload : { errCode }
});

export const setSignOutOpen = (flag) =>
({
	type    : 'SET_SIGN_OUT_OPEN',
	payload : { flag }
});

export const setRaiseHandPeerId = (peerId) =>
({
	type    : 'SET_RAISE_HAND_PEER_ID',
	payload : { peerId }
});

export const setAuditRaiseHandOpen = (flag) =>
({
	type    : 'SET_AUDIT_RAISE_HAND_OPEN',
	payload : { flag }
});

export const setForceMuteAllOpen = (flag) =>
({
	type    : 'SET_FORCE_MUTE_ALL_OPEN',
	payload : { flag }
});

export const setRecordConfirmOpen = (flag) =>
({
	type    : 'SET_RECORD_CONFIRM_OPEN',
	payload : { flag }
});

export const setStopAllVideoInProgress = (flag) =>
({
	type    : 'STOP_ALL_VIDEO_IN_PROGRESS',
	payload : { flag }
});

export const setStopAllScreenSharingInProgress = (flag) =>
({
	type    : 'STOP_ALL_SCREEN_SHARING_IN_PROGRESS',
	payload : { flag }
});

export const setCloseMeetingInProgress = (flag) =>
({
	type    : 'CLOSE_MEETING_IN_PROGRESS',
	payload : { flag }
});

export const setClearChatInProgress = (flag) =>
({
	type    : 'CLEAR_CHAT_IN_PROGRESS',
	payload : { flag }
});

export const setClearFileSharingInProgress = (flag) =>
({
	type    : 'CLEAR_FILE_SHARING_IN_PROGRESS',
	payload : { flag }
});

export const setRoomPermissions = (roomPermissions) =>
({
	type    : 'SET_ROOM_PERMISSIONS',
	payload : { roomPermissions }
});

export const setAllowWhenRoleMissing = (allowWhenRoleMissing) =>
({
	type    : 'SET_ALLOW_WHEN_ROLE_MISSING',
	payload : { allowWhenRoleMissing }
});

export const toggleSelfView = (flag) =>
({
	type    : 'TOGGLE_SELF_VIEW',
	payload : { flag }
});

export const setJoinError = (joinError) =>
({
	type    : 'SET_JOIN_ERROR',
	payload : { joinError }
});

export const setConfig = (config) =>
({
	type    : 'SET_CONFIG',
	payload : { config }
});

export const setConfId = (confId) =>
({
	type    : 'SET_CONF_ID',
	payload : { confId }
});

export const setChairPeerId = (peerId) => ({
	type    : 'SET_CHAIR_PEER_ID',
	payload : { peerId }
});

export const setLockPeerId = (peerId) => ({
	type    : 'SET_LOCK_PEER_ID',
	payload : { peerId }
});

export const setVoteEnable = (flag) => ({
	type    : 'SET_VOTE_ENABLE',
	payload : { flag }
});

export const setSubtitleEnable = (flag) => ({
	type    : 'SET_SUBTITLE_ENABLE',
	payload : { flag }
});

export const setSubtitleState = (subtitleState) => ({
	type    : 'SET_SUBTITLE_STATE',
	payload : { subtitleState }
});

export const setSubtitleErrCode = (errCode) => ({
	type    : 'SET_SUBTITLE_ERR_CODE',
	payload : { errCode }
});

// recordingPromptEnable
export const setRecordingPromptEnable = (flag) => ({
	type    : 'SET_RECORDING_PROMPT_ENABLE',
	payload : { flag }
});

// hasRecordingPrompt
export const setHasRecordingPrompt = (flag) => ({
	type    : 'SET_HAS_RECORDING_PROMPT',
	payload : { flag }
});

export const setCohostSuids = (suids) => ({
	type    : 'SET_COHOST_SUIDS',
	payload : { suids }
});

export const addCohostSuid = (suid) => ({
	type    : 'ADD_COHOST_SUID',
	payload : { suid }
});

export const removeCohostSuid = (suid) => ({
	type    : 'REMOVE_COHOST_SUID',
	payload : { suid }
});